import { render, staticRenderFns } from "./InfoFlowPromotion.vue?vue&type=template&id=cd441032&scoped=true&"
import script from "./InfoFlowPromotion.vue?vue&type=script&lang=js&"
export * from "./InfoFlowPromotion.vue?vue&type=script&lang=js&"
import style0 from "./InfoFlowPromotion.vue?vue&type=style&index=0&id=cd441032&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd441032",
  null
  
)

export default component.exports